export const CUSTOMER_ID_COOKIE_NAME = 'customerId';
export const UNAUTHORIZED_CUSTOMER_ID_COOKIE_NAME = '_ym_uid';
export const SAVED_CONFIGURATION_LAMINATE_COOKIE = 'userProjectConfigurationLaminatSaved';
export const REGION_ID_COOKIE = '_regionID';
